module.exports = __webpack_public_path__ + "static/media/Rastislav_Stracina.4d946e9e.jpg";